/**
 * Tipus d'IVA de l'allotjament — plans/preus-en-crear-reserves.md, decisió 4 (11-OCT-2026):
 * «10 % a tot, però com a dada de configuració, mai a foc».
 *
 * AQUEST ÉS L'ÚNIC LLOC on viu el tipus. Cap component ni cap funció l'escriu: tots el demanen a
 * `accommodationVatPercent(propertyId)`. Per canviar-lo:
 *
 * - a tot arreu: `defaultPercent`;
 * - en una propietat (p. ex. si els apartaments passen al 21 %): una entrada a `byPropertyId` amb
 *   l'id de propietat de Beds24.
 *
 * És un tant per cent (10 = 10 %; es pot escriure 5.2). El valida `vatRateFromPercent` de
 * `@guilleumes/types` allà on es fa servir: un valor invàlid no llança, simplement no hi ha avís.
 *
 * Avui és una dada dins del codi del frontend perquè no demana cap migració. Si el tipus ha de
 * poder-se canviar sense desplegar, el pas següent és servir-lo des del backend i que aquesta
 * funció el llegeixi d'allà: la signatura ja no canviaria.
 */

export interface AccommodationVatConfig {
  /** Tipus per a tota propietat que no surti a `byPropertyId`. */
  defaultPercent: number;
  /** Excepcions per id de propietat de Beds24. */
  byPropertyId: Readonly<Record<number, number>>;
}

export const ACCOMMODATION_VAT_CONFIG: AccommodationVatConfig = {
  defaultPercent: 10,
  byPropertyId: {},
};

/** El tipus d'IVA de l'allotjament d'una propietat, en tant per cent. */
export function accommodationVatPercent(
  propertyId?: number | null,
  config: AccommodationVatConfig = ACCOMMODATION_VAT_CONFIG,
): number {
  if (propertyId != null && Object.prototype.hasOwnProperty.call(config.byPropertyId, propertyId)) {
    return config.byPropertyId[propertyId];
  }
  return config.defaultPercent;
}
